<div class="modal-content">
  <div class="modal-header">
    <div class="mb-3">
      <button
        type="button"
        class="btn-close float-right"
        data-bs-dismiss="modal"
        aria-label="Close"
        (click)="closeModal()"
        >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <h4 class="modal-title text-center w-100" id="modal-basic-title">
      {{ "downloadAndReqDocuments.downloadAndRequestDocuments" | cxTranslate }}
    </h4>
  </div>
  <div class="modal-body">
    @if (showErrorMessage) {
      <div
        class="alert alert-danger alert-dismissible fade show"
        role="alert"
        >
        <strong>{{
          "configurators.downloadDocuments.errorMsg" | cxTranslate
        }}</strong>
        <button
          type="button"
          class="close"
          data-dismiss="alert"
          aria-label="Close"
          >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    }
    <div class="col-12 mt-3">
      <h5 class="text-black">
        {{ "downloadAndReqDocuments.downloadNow" | cxTranslate }}
      </h5>
      @for (document of documentTypes; track document; let i = $index) {
        <div class="form-check form-check-inline mb-2 col-12">
          <input
            (change)="onChangeDownloadBox($event, document.documentValue)"
            class="form-check-input"
            type="checkbox"
            name="passwordOptions"
            [id]="document.documentValue"
            [disabled]="document.disabled"
            [value]="document.documentValue"
            />
            <label class="form-check-label mb-2 download-doc-label" [for]="document.documentValue">
              {{ document.documentName }}</label
              >
            </div>
          }
        </div>
        <div class="col-md-12 text-center">
          <button
        [disabled]="
          !selectedDownloadDocTypes ||
          selectedDownloadDocTypes.length < 1 ||
          disableButtons
        "
            (click)="downloadDocuments()"
            type="submit"
            class="btn btn-primary"
            >
            {{ "downloadAndReqDocuments.download" | cxTranslate }}
          </button>
        </div>

        @if (showDesignDocument) {
          <div class="col-12 mt-3">
            <h5 class="text-black">
              {{ "downloadAndReqDocuments.designdocuments" | cxTranslate }}
            </h5>
            @for (email of emailTypes; track email; let i = $index) {
              <div class="form-check form-check-inline mb-2 col-12">
                <input
                  (change)="onChangeMailBox($event, email.value)"
                  class="form-check-input"
                  type="checkbox"
                  name="passwordOptions"
                  [id]="email.value"
                  [value]="email.value"
                  [disabled]="email.disabled"
                  [checked]="email.checked"
                  />
                  <label class="form-check-label mb-2 download-doc-label" [for]="email.value">
                    {{ email.emailType }}</label
                    >
                  </div>
                }
              </div>
              <div class="col-md-12 text-center">
                <button
          [disabled]="
            !selectedReqDocTypes ||
            selectedReqDocTypes.length < 1 ||
            disableButtons
          "
                  (click)="reqForDownloadDocuments()"
                  type="submit"
                  class="btn btn-primary"
                  >
                  {{ "downloadAndReqDocuments.requestSinkLineDrawing" | cxTranslate }}
                </button>
              </div>
        } @else {
          <div class="col-12 mt-3">
            <div class="warning-box">
              <span class="warning-icon">&#9888;&#65039;</span>
              <div class="warning-content">
                <p class="warning-text">
                  {{ "downloadAndReqDocuments.designDocumentsUnavailable1" | cxTranslate }}
                </p>
              </div>
            </div>
          </div>
        }
          </div>
        </div>
